import { useEffect, useRef } from "react";
const emptyObject = {};
function useFormOverrideValues(formApi, updateMode, _name, _fields, config = emptyObject, verbose) {
  const { overrideValues } = config;
  const prevSource = useRef({ verbose });
  useEffect(() => {
    const verbose2 = prevSource.current.verbose;
    if (overrideValues) {
      formApi.reset(updateMode, overrideValues, false);
      if (verbose2) console.log(`[useCreateForm] -- Update Overridden Values.`);
    }
  }, [formApi, updateMode, overrideValues]);
  useEffect(() => void (prevSource.current = { verbose }), [verbose]);
}
export {
  useFormOverrideValues
};
//# sourceMappingURL=useFormOverrideValues.js.map
